// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"Event_sectionWrapper__301f8","title":"Event_title__13Q0u","withRoundedBorder":"Event_withRoundedBorder__3lD_3","program":"Event_program__2ylLl"};